import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import GroupService from "../services/group.service";

const initialState = {
  data: { list: [], total: 0 },
  ui: { columns: [] },
  hierarchy: { list: [], total: 0 },
  loading: false,
  error: null,
};

export const getGroups = createAsyncThunk(
  "group/getGroups",
  async ({ search }, thunkAPI) => {
    try {
      const response = await GroupService.getGroups(search);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message, "error"));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getGroupUi = createAsyncThunk(
  "group/getGroupUi",
  async (_, thunkAPI) => {
    try {
      const response = await GroupService.getGroupUi();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message, "error"));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createGroup = createAsyncThunk(
  "group/createGroup",
  async ({ group }, thunkAPI) => {
    try {
      const response = await GroupService.createGroup(group);
      thunkAPI.dispatch(setMessage("Group created successfully", "success"));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message, "error"));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateGroup = createAsyncThunk(
  "group/updateGroup",
  async ({ group }, thunkAPI) => {
    try {
      const response = await GroupService.updateGroup(group);
      thunkAPI.dispatch(setMessage("Group updated successfully", "success"));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message, "error"));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteGroup = createAsyncThunk(
  "group/deleteGroup",
  async ({ id }, thunkAPI) => {
    try {
      const response = await GroupService.deleteGroup(id);
      thunkAPI.dispatch(setMessage("Group deleted successfully", "success"));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message, "error"));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getGroupHierarchy = createAsyncThunk(
  "group/getGroupHierarchy",
  async (_, thunkAPI) => {
    try {
      const response = await GroupService.getGroupHierarchyData();
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message, "error"));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const groupSlice = createSlice({
  name: "group",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // getGroups
      .addCase(getGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getGroupUi
      .addCase(getGroupUi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupUi.fulfilled, (state, action) => {
        state.loading = false;
        state.ui = action.payload;
      })
      .addCase(getGroupUi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // createGroup
      .addCase(createGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createGroup.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // updateGroup
      .addCase(updateGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGroup.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // deleteGroup
      .addCase(deleteGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGroup.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getGroupHierarchy
      .addCase(getGroupHierarchy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupHierarchy.fulfilled, (state, action) => {
        state.loading = false;
        state.hierarchy = action.payload;
      })
      .addCase(getGroupHierarchy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

const { reducer } = groupSlice;
export default reducer;
